<template>
    <card>
      <slot slot="header">
        <v-toolbar-title>
          <v-icon>vpn_key</v-icon>
          Esqueci minhas senha
        </v-toolbar-title>
      </slot>

      <slot slot="body">
        <v-form>
          <v-container grid-list-lg fluid>
            <v-layout row justify-center align-center wrap>
              <v-flex xs12>
                <v-text-field prepend-icon="person" name="email" label="E-mail" type="text" autofocus
                              v-model="email"/>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <v-btn dark class="gradient mx-auto" @click="reset">
                  Enviar link para redefinir senha
                </v-btn>
                <v-btn flat href="#/">Voltar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </slot>
    </card>
</template>

<style scoped>
  .gradient {
    background: linear-gradient(40deg, #4a97ce, #5fbf8d);
  }
</style>

<script>
  import Card from '../shared/Card'

  export default {
    components: {Card},
    data () {
      return {
        email: ''
      }
    },
    methods: {
      reset () {
        this.$http.post('auth/forgot-password', {email: this.email})
          .then(() => {
          }, (res) => {
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/Forgot.vue